import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {Alert, AlertStatus} from 'app/core/interfaces/alert.interface';
import {ToastrAlertsService} from 'app/core/services/alerts/toastr-alerts.service';
import {Subscription} from 'rxjs';

const colorMap = {
    info: 'alert-info',
    warning: 'alert-warning',
    error: 'alert-danger',
    danger: 'alert-danger',
    strongWarning: 'alert-strong-warning',
};

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnChanges, OnDestroy {
    @Input() alert: Alert;
    @Output() dismiss = new EventEmitter<Alert>(null);

    @HostBinding('class')
    get colorClass() {
        return colorMap[this.alert.status] || colorMap.info;
    }

    subs: Subscription[] = [];
    timeoutId: NodeJS.Timeout;

    constructor(private toastr: ToastrAlertsService) {}

    ngOnChanges() {
        const isAutoHideAlert = this.alert.status === AlertStatus.info || this.alert.status === AlertStatus.success;
        if (this.alert && isAutoHideAlert) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.toastr.dismiss(this.alert.body);
                this.dismissAlert(this.alert);
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            }, 10000);
        }

        this.subs.push(
            this.toastr.show(this.alert.body, this.alert.status)?.onHidden.subscribe(alert => {
                this.dismissAlert(this.alert);
            })
        );
    }

    dismissAlert(alert: Alert) {
        this.dismiss.emit(alert);
    }

    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
        clearTimeout(this.timeoutId);
    }
}
